// Shared helper to read Seiva design tokens (CSS custom properties) at runtime.
//
// Why this exists: hex colors used by JS (ECharts theme, @mention badge
// highlighting) used to be hardcoded literals that ignored dark mode and
// partnership branding. Reading the live custom property instead keeps a single
// source of truth (`assets/css/app.css :root` + `html.dark` re-binds + the
// inline `<html style>` branding overrides applied by `root.html.heex`).
//
// IMPORTANT: read inside `mounted()` / at render time, NOT at module scope —
// branding is applied to `<html>` after the bundle loads, and dark mode flips
// at runtime.

// Returns the resolved value of a CSS custom property on :root, or `fallback`.
//
// Guards against the two failure modes:
//   * unsupported / unset property  → "" → fallback
//   * a browser that returns an unresolved `var(--x)` literal (some engines do
//     this for aliased custom properties) → fallback
export function cssVar(name, fallback = "") {
  try {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim()
    if (!raw || raw.includes("var(")) return fallback
    return raw
  } catch {
    return fallback
  }
}
